import "./Loader.css";

export default function Loader() {
  return (
    <ul className="loader-list">
      <li>
        <div className="loader-5">
          <span></span>
        </div>
      </li>
    </ul>
  );
}
